export * from './default-slick-responsive';
